export default "__VITE_ASSET__99b6a74e__"